import { render, staticRenderFns } from "./ChannelDispose.vue?vue&type=template&id=49b026cd&scoped=true"
import script from "./ChannelDispose.vue?vue&type=script&lang=js"
export * from "./ChannelDispose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b026cd",
  null
  
)

export default component.exports